<template>
    <u-btn-flat-pill v-bind="$attrs" color="accent" @click="$emit('click')">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-btn-flat-pill>
</template>

<script>
import UBtnFlatPill from "@/components/publish/styles/buttons/u-btn-flat-pill.vue";

export default {
    props: {},
    components: {
        UBtnFlatPill,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
